import Vue from 'vue';
import { sessionKeys } from '@/data/constants';

export default Vue.extend({
  data() {
    return {
      title: '',
      isSkipButtonClicked: false
    };
  },
  computed: {
    configuration() {
      return this.$store.state.utils.configuration;
    },
    steps() {
      return (this as any).configuration.introVideosSteps;
    },
    assets() {
      return this.$store.state.endPoints[((this as any).type)].customsAssets;
    },
    isMobile() {
      return this.$store.getters['utils/returnScreenSize'].includes('mobile');
    },
    translations() {
      return this.$store.state.translations.data;
    }
  },
  watch: {
    translations() {
      this.title = this.translations[this.steps[0].title];
    },
  },
  methods: {
    setConfigurationProperty(flag: boolean) {
      this.$store.commit(
        'utils/SET_PROPERTY_CONFIGURATION',
        { property: 'enableIntroVideo', value: flag },
      );
    },
    onCloseModal() {
      if (!this.isSkipButtonClicked) {
        if ((this as any).type === 'ugcentrypoint') {
          (this as any).$ugcDataLayer.logAnalyticsEvent({
            type: (this as any).$ugcDataLayer.types.closeIntroVideo,
            eventLabel: 'Close Modal',
          });
        } else {
          this.$customizerDataLayer.logAnalyticsEvent({
            type: this.$customizerDataLayer.types.customizerIntroVideo,
            eventLabel: 'Close Modal',
          });
        }
      }
      this.setConfigurationProperty(false);
    },
    onNext() {
      if ((this as any).type === 'ugcentrypoint') {
        (this as any).$ugcDataLayer.logAnalyticsEvent({
          type: (this as any).$ugcDataLayer.types.introVideo,
          eventLabel: 'Skip To Get Started',
        });
      } else {
        this.$customizerDataLayer.logAnalyticsEvent({
          type: this.$customizerDataLayer.types.customizerIntroVideo,
          eventLabel: 'Skip To Get Started',
        });
      }

      this.isSkipButtonClicked = true;
      this.setConfigurationProperty(false);
      this.$modal.hide('introVideos');
      if ((this as any).autoOpen) {
        this.$eventBus.$emit('ugcep-hide-intro-video');
      } else {
        this.$modal.show(
          this.configuration.ugc.enableNewUgcTermConditions ?
            'newTermsConditionModal' : 'termsConditionModal'
        );
      }
    },
    onSlideChange(value: any) {
      this.title = this.translations[value.title];
    },
  },
  mounted() {
    this.isSkipButtonClicked = false;

    if (this.$cookies.get(sessionKeys.ugcIntroVideos)) {
      this.setConfigurationProperty(false);
      return;
    }

    if (this.steps) {
      this.title = this.translations && this.translations[this.steps[0].title];
    }

    if ((this as any).autoOpen) {
      this.$modal.show('introVideos');
    }
  },
});
